import { get } from "../api.js";

/**
 * @typedef {import("../jsdoc/ApprovedContractor.js").ApprovedContractor} ApprovedContractor
 */

/**
 * Gets list of Approved Contractors
 * @returns {Promise<ApprovedContractor[]>}
 */
export const getApprovedContractorsList = () =>
  get("/sewp5public/approvedcontractors/list").then(({ data }) => data);
